import React from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import { TextButtonLink } from 'js/design_system/link/TextButtonLink';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

import PremiumLock from './PremiumLock';
import { NavButtonLink } from './buttonStyles';
import { ChurnedUserReactivationDiscount } from './types';
import _Text from "ChurnedUserReactivationButton-Text.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ChurnedUserReactivationButton.tsx?styleId=Text";
import _NoWrapSpan from "ChurnedUserReactivationButton-NoWrapSpan.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ChurnedUserReactivationButton.tsx?styleId=NoWrapSpan";
import _ButtonWrapper from "ChurnedUserReactivationButton-ButtonWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ChurnedUserReactivationButton.tsx?styleId=ButtonWrapper";


const TRIGGER = 'reactivate_button';

const Text = /*#__PURE__*/styled("div", null, {
  displayName: "Text",
  styles: _Text
});

const NoWrapSpan = /*#__PURE__*/styled("span", null, {
  displayName: "NoWrapSpan",
  styles: _NoWrapSpan
});

const ButtonWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonWrapper",
  styles: _ButtonWrapper
});

type ChurnedUserReactivationButtonProps = {
  discount: ChurnedUserReactivationDiscount;
  isMobileNav: boolean;
};

export default function ChurnedUserReactivationButton({
  discount: { offer, value },
  isMobileNav,
}: ChurnedUserReactivationButtonProps) {
  const checkoutUrl = routes.checkout_path({
    feature: 'churned_user_reactivation',
    trigger: TRIGGER,
    from_navbar: true,
  });

  const buttonContent =
    offer === 'discount' ? (
      <Text>
        Reactivate Premium, <NoWrapSpan>{value} OFF</NoWrapSpan>
      </Text>
    ) : (
      <Text>
        Reactivate Premium <NoWrapSpan>for {value}</NoWrapSpan>
      </Text>
    );

  return (
    <ButtonWrapper>
      <ImpressionWatcher source={TRIGGER} extra={{ offer }}>
        {isMobileNav ? (
          <TextButtonLink
            href={checkoutUrl}
            icon={<PremiumLock circleColor="gold" lockColor="white" />}
            trackClick={{ source: 'churned_user_reactivation_button' }}
          >
            {buttonContent}
          </TextButtonLink>
        ) : (
          <NavButtonLink
            href={checkoutUrl}
            icon={<PremiumLock circleColor="white" lockColor="blue" />}
            trackClick={{ source: 'churned_user_reactivation_button' }}
          >
            {buttonContent}
          </NavButtonLink>
        )}
      </ImpressionWatcher>
    </ButtonWrapper>
  );
}
